import { AfterViewInit, Component, ElementRef, HostListener, Inject, OnDestroy, ViewChild } from '@angular/core';
import { GeneralService } from 'src/app/shared/services/general.service';
import SignaturePad from 'signature_pad';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SignatureService } from '../../services/signature.service';
import { Subscription } from 'rxjs';
import { AppLoadingService } from '../../services/apploading.service';
import { AmplifyService } from 'aws-amplify-angular';

@Component({
    selector: 'signature-pad.component',
    templateUrl: './signature-pad.component.html',
    styleUrls: ['./signature-pad.component.scss'],
})
export class SignaturePadComponent implements AfterViewInit, OnDestroy {

    @ViewChild('canvas', { static: true }) signaturePadElement;
    signaturePad: any;
    canvasWidth: number;
    canvasHeight: number;

    filesSubscription: Subscription;

    init = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data,
        public dialog: MatDialog,
        private elementRef: ElementRef,
        protected als: AppLoadingService, 
        protected gs: GeneralService,
        protected as: AmplifyService,
        protected signatureService: SignatureService
    ) { 

        this.filesSubscription = this.gs.filesChangeSubscription$.subscribe(async result => {

            await this.als.setLoaded(true, 'signature');
            if (result?.files?.at(0)?.original?.tags?.indexOf(308) > -1) {
              await this.gs.doConfirmSignedIn(false);
              this.signatureService.getFileupload().setCallback([]);
              this.dialog.getDialogById(this.data.modalId).close();
            }
        });

    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.default();
    }

    default() {
       
        const canvas: any = this.elementRef.nativeElement.querySelector('canvas');
        var ratio =  1;//Math.max(window.devicePixelRatio || 1, 1);
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvas.getContext("2d").scale(ratio, ratio);

        let signature = this.gs.getProfiledata();
        if(signature?.signature){

            let signatureFile = signature.signature.variations.filter(item => item?.resizeType == 'original')[0];
            this.getFile(signatureFile.filename,(image)=>{
                this.signaturePad.fromDataURL(image,{
                    ratio: ratio,
                    width: canvas.width,
                    height: canvas.height
                });
            });
        } else if (this.signaturePad) {
            this.signaturePad.clear(); // Clear the pad on init
        }
        setTimeout(()=> this.init=true,100);
    }

    getFile(url, callback) {
        const result = this.as.storage().get(url, {
            level: 'protected',
            download: true
        }).then(result => {
            let base64String = btoa(new Uint8Array(result.Body).reduce((data, byte)=> {return data + String.fromCharCode(byte);}, ''));
            callback('data:image/jpg;base64, ' +base64String);   
        });
    }

    
    ngOnDestroy() {
        this.filesSubscription?.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.signaturePad = new SignaturePad(this.signaturePadElement.nativeElement);
        this.signaturePad.clear();
        this.signaturePad.penColor = 'rgb(0,0,0)';
        this.default();
    }

    isCanvasBlank(): boolean {
        if (this?.signaturePad) {
            return this.signaturePad.isEmpty() ? true : false;
        }
    }

    clear() {
        this.signaturePad.clear();
    }

    undo() {
        const data = this.signaturePad.toData();
        if (data) {
          data.pop(); // remove the last dot or line
          this.signaturePad.fromData(data);
        }
    }

    async delete(){
        
        await this.signatureService.deleteSignature(this.data.file_id,this.data.person_id).then(result => {
            if (this.signaturePad) {
                this.signaturePad.clear(); // Clear the pad on init
            }
            this.gs.doConfirmSignedIn(false);      
        }); 
    }
    async save(){
     
        const img = this.signaturePad.toDataURL();
        await this.signatureService.updateSignature(this.data?.person_id,img,this.data?.file_id || false);
    }


}